<template>
  <v-container fluid>
    <v-row class="my-n6">
      <v-col v-if="inputLabel && !hideLabel" cols="auto" :md="labelWidth" class="mt-1">
        <span class="body-2">
          {{inputLabel}}<span v-if="$attrs.rules" class="text-h5 error--text d-inline">*</span>
        </span>
      </v-col>
      <!-- <v-col cols="auto" class="mt-2">
        :
      </v-col> -->
      <v-col :cols="12" md>
        <v-text-field
          v-if="!isTextArea"
          v-model="displayValue"
          :label="inputLabel"
          required
          :clearable="!disabled"
          solo
          outlined
          :disabled="disabled"
          dense
          flat
          v-bind="!disabled ? $attrs : null"
          :loading="loading"
        ></v-text-field>
        <v-textarea
          v-else
          v-model="displayValue"
          :label="inputLabel"
          required
          :clearable="!disabled"
          solo
          :disabled="disabled"
          outlined
          dense
          flat
          :rows="1"
          auto-grow
          v-bind="!disabled ? $attrs : null"
          :loading="loading"
        ></v-textarea>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'CommonTextInput',
  props: {
    inputLabel: String,
    isTextArea: {
      type: Boolean,
      default: false,
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    value: {},
    labelWidth: {
      type: Number,
      default: 2,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    displayValue: {
      get() {
        return this.value;
      },
      set(modifiedValue) {
        this.$emit('input', modifiedValue);
      },
    },
  },
};
</script>

<style>

</style>
